









































































































































































































































































































































































































import { Component, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Editor from "@tinymce/tinymce-vue";
import IntTimePicker from "@/components/int-time-picker.vue";
import Ajax from "@/lib/ajax";
import { Survey } from "@/lib/tinymce-initial-value";
import TinymceInit from "@/lib/TinymceInit";
import Court from "@/store/entities/booking/court";
import ajax from "@/lib/ajax";
import SupplierOffer from "@/store/entities/booking/supplierOffer";
import CreateDate from "./components/create-date.vue";
import moment from "moment";
import CreateTime from "./components/create-time.vue";
import CreateOffer from "./components/create-offer.vue";
import SelectedModal from "./components/selected-modal.vue";
import EditOffer from "./components/edit-offer.vue";

TinymceInit.height = 300;
class CheckObj {
  courtId: number;
  supplierId: number;
}
@Component({
  components: {
    IntTimePicker,
    Editor,
    CreateDate,
    CreateOffer,
    CreateTime,
    EditOffer,
    SelectedModal,
  },
})
export default class CreateSupplierOffer extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;

  @Prop({ type: Number, default: 0 }) courtId: number;

  @Prop({ type: Number, default: 0 }) supplierId: number;

  offerTimeSlotId: number = 0;
  modelValue: number = 1;
  createDateShow: boolean = false;
  selectedModalShow: boolean = false;
  supplierOffer: SupplierOffer = new SupplierOffer();
  survey = Survey;
  checkObj: CheckObj = new CheckObj();
  tinymceInit = TinymceInit;
  courtList: Array<Court> = [];
  supplierList: any = [];
  current: number = 0;
  supplierOfferId: number = 0;
  timeModelShow: boolean = false;
  offerDateSlotId: number = 0;
  createOfferShow: boolean = false;
  editOfferShow: boolean = false;
  stepList: Array<any> = [
    {
      //status 0:进行中 1,已完成 2待进行
      status: 0,
      content: "选择球场与供应商",
    },
    {
      status: 2,
      content: "校验供应商是否为该球场已经报价",
    },
    {
      status: 2,
      content: "完成添加/修改(日期&时间&报价)",
    },
  ];
  editOffer(row) {
    this.$store.commit("supplierOfferItem/edit", row);
    this.editOfferShow = true;
  }
  /**
   * @description:打开预订须知弹窗
   */
  openSelectModal(modelValue) {
    this.modelValue = modelValue;
    this.selectedModalShow = true;
  }
  /**
   * @description:获取成功回调
   */

  getModelContent(params) {
    if (params) {
      let data = JSON.parse(decodeURIComponent(params));
      if (data.modelValue == 1) {
        this.supplierOffer.notice = data.content;
      } else {
        this.supplierOffer.cancelNotice = data.content;
      }
    }
  }
  /**
   * @description:根据日起段id获取报价列表
   */
  async getSupplierOfferItems() {
    await this.$store.dispatch({
      type: "supplierOfferItem/getAll",
      data: {
        offerTimeSlotId: this.offerTimeSlotId,
      },
    });
  }
  /**
   * @description：编辑日期段
   */
  openEditDateModel(row) {
    this.$store.commit("offerDateSlot/edit", row);
    this.createDateShow = true;
  }

  async openCreateOfferModel(id) {
    this.offerTimeSlotId = id;
    this.createOfferShow = true;
  }
  get timeList() {
    let list = this.$store.state.offerTimeSlot.list;
    if (list && list.length > 0) {
      list[0]["_highlight"] = true;
    }
    return list;
  }
  get supplierOfferItems() {
    return this.$store.state.supplierOfferItem.list;
  }
  get offerDateSlotList() {
    let list = this.$store.state.offerDateSlot.list;
    if (list && list.length > 0) {
      list[0]["_highlight"] = true;
    }
    return list;
  }
  get offerDateTypeDics() {
    return this.$store.state.common.offerDateTypeDic;
  }
  get paymethods() {
    return this.$store.state.common.paymethodsDic;
  }
  /**
   * @description:删除时间段
   */
  async delOfferTime(id) {
    await this.$store.dispatch({
      type: "offerTimeSlot/delete",
      data: {
        id,
      },
    });
    await this.loadTime();
    this.$Message.success({
      content: "删除成功",
    });
  }
  /**
   * @description:删除报价啊
   */
  async delSupplierOfferItem(id) {
    await this.$store.dispatch({
      type: "supplierOfferItem/delete",
      data: {
        id,
      },
    });
    this.$Message.success("删除报价成功");
    await this.getSupplierOfferItems();
  }

  /**
   * @description:删除日期段
   */
  async delOfferDate(id) {
    await this.$store.dispatch({
      type: "offerDateSlot/delete",
      data: {
        id,
      },
    });
    this.$Message.success({
      content: "删除成功",
    });
    await this.loadDate();
  }

  /**
   * @description:获取日期段
   */
  async getOfferDateSlot() {
    await this.$store.dispatch({
      type: "offerDateSlot/getAll",
      data: {
        supplierOfferId: this.supplierOffer.id,
        skipCount: 0,
        maxResultCount: 1000,
      },
    });
    if (this.offerDateSlotList && this.offerDateSlotList.length > 0) {
      this.offerDateSlotId = this.offerDateSlotList[0].id;
    } else {
      this.$store.commit("offerTimeSlot/setList");
    }
  }
  /**
   * @description:日期段表格切换回调，更新时间段列表
   */
  async dateTableChange(currentRow) {
    this.offerDateSlotId = currentRow.id;
    await this.getTimeList();
    if (this.timeList && this.timeList.length > 0) {
      this.offerTimeSlotId = this.timeList[0].id;
      await this.getSupplierOfferItems();
    }
  }
  /**
   * @description:时间段表格切换回调，更新时间段列表
   */
  async timeTableChange(currentRow) {
    this.offerTimeSlotId = currentRow.id;
    await this.getSupplierOfferItems();
  }

  /**
   * @description:根据日期段id获取时间段列表
   */

  async getTimeList() {
    await this.$store.dispatch({
      type: "offerTimeSlot/getAll",
      data: {
        offerDateSlotId: this.offerDateSlotId,
        skipCount: 0,
        maxResultCount: 1000,
      },
    });
    //日期段列表为空，则清空报价表格
    if (this.timeList && this.timeList.length == 0) {
      this.$store.commit("supplierOfferItem/setList");
    }
  }
  /**
   * @description：重新再时间段开始加载
   */
  async loadTime() {
    await this.getTimeList();
    if (this.timeList && this.timeList.length > 0) {
      this.offerTimeSlotId = this.timeList[0].id;
      await this.getSupplierOfferItems();
    }
  }
  /**
   * @description：重新再日期段开始加载
   */

  async loadDate() {
    await this.getOfferDateSlot();
    if (this.offerDateSlotList && this.offerDateSlotList.length > 0) {
      this.offerDateSlotId = this.offerDateSlotList[0].id;
      await this.loadTime();
    }
  }

  openCreateDateModal() {
    this.$store.commit("offerDateSlot/edit", {});
    this.supplierOfferId = this.supplierOffer.id;
    this.createDateShow = true;
  }
  // 保存订单
  save() {
    this.$Message.success("点击了确认");
    this.current = 0;
    this.$emit("input", false);
    this.$emit("save-success");
  }
  openEditTimeModel(row) {
    this.$store.commit("offerTimeSlot/edit", row);
    this.timeModelShow = true;
  }

  openAddTimeModel(row) {
    this.$store.commit("offerTimeSlot/edit", {});
    this.offerDateSlotId = row.id;
    this.timeModelShow = true;
  }
  timeColumns = [
    {
      title: "开始时间",
      render: (h: any, params: any) => {
        return h("span", params.row.startTime);
      },
    },
    {
      title: "结束时间",
      render: (h: any, params: any) => {
        return h("span", params.row.endTime);
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      align: "center",
      width: 200,
      slot: "action",
    },
  ];
  columns = [
    {
      title: "开始时间",
      key: "startDate",
      tree: true,
      render: (h: any, params: any) => {
        if (params.row.startDate) {
          return h("span", moment(params.row.startDate).format("YYYY-MM-DD"));
        } else if (params.row.startTime) {
          return h("span", params.row.startTime);
        } else {
          return h("span", "");
        }
      },
    },
    {
      title: "结束时间",
      key: "endDate",
      render: (h: any, params: any) => {
        if (params.row.endDate) {
          return h("span", moment(params.row.endDate).format("YYYY-MM-DD"));
        } else if (params.row.endTime) {
          return h("span", params.row.endTime);
        } else {
          return h("span", "");
        }
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      align: "center",
      width: 200,
      slot: "action",
    },
  ];
  supplierOfferItemColumns = [
    {
      title: "供应商报价",
      render: (h: any, params: any) => {
        return h("span", params.row.offerPrice);
      },
    },
    {
      title: "球洞类型",
      render: (h: any, params: any) => {
        return h("span", params.row.holeType == 0 ? "18洞" : "9洞");
      },
    },
    {
      title: "服务",
      render: (h: any, params: any) => {
        return h("span", params.row.services);
      },
    },
    {
      title: "加利润后价格",
      render: (h: any, params: any) => {
        return h("span", params.row.price);
      },
    },
    {
      title: "预付金",
      render: (h: any, params: any) => {
        return h("span", params.row.amount);
      },
    },
    {
      title: "日期类型",
      render: (h: any, params: any) => {
        return h("span", this.offerDateTypeDics[params.row.offerDateTypeId]);
      },
    },
    {
      title: "支付方式",
      key: "payMethod",
      render: (h: any, params: any) => {
        return h("span", this.paymethods[params.row.payMethod]);
      },
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString()
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      align: "center",
      slot: "action",
    },
  ];

  /**
   * @description：上一步
   */
  backBasicInfo() {
    (this.$refs.supplierOfferForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.supplierOffer.courtId = this.checkObj.courtId;
        this.supplierOffer.supplierId = this.checkObj.supplierId;
        this.supplierOffer.cancelDate = this.supplierOffer.cancelDate * 60; //提交的时候把小时转为分钟
        let type = this.supplierOfferId
          ? "supplierOffer/update"
          : "supplierOffer/create";
        await this.$store
          .dispatch({
            type,
            data: this.supplierOffer,
          })
          .then(async (res) => {
            if (res && res.data && res.data.result) {
              //返回上一级
              this.current=0;
              //默认都取第一个
              this.supplierOffer = res.data.result;
              this.$set(this.stepList[0], "status", 0);
              this.$set(this.stepList[1], "status", 2);
            } else {
              this.$Message.error(
                `${this.supplierOfferId ? "编辑" : "添加"}基本信息失败`
              );
            }
          });
      } else {
        this.$Message.error({
          content: "表单校验不通过,请检查",
        });
      }
    });
  }

  /**
   * @description：提交基本信息
   */
  confimBasicInfo() {
    (this.$refs.supplierOfferForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.supplierOffer.courtId = this.checkObj.courtId;
        this.supplierOffer.supplierId = this.checkObj.supplierId;
        this.supplierOffer.cancelDate = this.supplierOffer.cancelDate * 60; //提交的时候把小时转为分钟
        let type = this.supplierOfferId
          ? "supplierOffer/update"
          : "supplierOffer/create";
        await this.$store
          .dispatch({
            type,
            data: this.supplierOffer,
          })
          .then(async (res) => {
            if (res && res.data && res.data.result) {
              //默认都取第一个
              this.supplierOffer = res.data.result;
              this.$store.commit("supplierOfferItem/setList");

              await this.loadDate();
              this.current++;
              this.$set(this.stepList[1], "status", 1);
              this.$set(this.stepList[2], "status", 0);
            } else {
              this.$Message.error(
                `${this.supplierOfferId ? "编辑" : "添加"}基本信息失败`
              );
            }
          });
      } else {
        this.$Message.error({
          content: "表单校验不通过,请检查",
        });
      }
    });
  }

  //#region

  /**
   * @description：校验选择球场
   */
  checkCourtId(rule: any, value: any, callback: any) {
    if (!this.checkObj.courtId) {
      callback(new Error("请选择球场"));
    } else {
      callback();
    }
  }
  /**
   * @description：校验供应商
   */
  checkSupplierId(rule: any, value: any, callback: any) {
    if (!this.checkObj.supplierId) {
      callback(new Error("请选择供应商"));
    } else {
      callback();
    }
  }
  /**
   * @description：点击下一步，校验表单验证，校验是否提供过报价
   */
  startCheck() {
    (this.$refs.checkObjForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.$Message.success("校验通过");
        await ajax
          .get(
            "/api/services/app/SupplierOffer/GetSupplierOfferByCourtIdAndSupplierId",
            {
              params: {
                supplierId: this.checkObj.supplierId,
                courtId: this.checkObj.courtId,
              },
            }
          )
          .then((res) => {
            this.current++;
            this.$set(this.stepList[0], "status", 1);
            this.$set(this.stepList[1], "status", 0);
            if (res && res.data) {
              if (res.data.result) {
                //获取报价id，然后展示报价
                this.supplierOffer = res.data.result;
                this.supplierOffer.cancelDate =
                  this.supplierOffer.cancelDate / 60;
                this.supplierOfferId = this.supplierOffer.id;
              } else {
                //需要新增
                this.supplierOffer.id = this.checkObj.supplierId;
                this.supplierOfferId = 0;
              }
            } else {
              this.$Message.error({
                content: "遇到未知错误,请联系管理员",
              });
            }
          });
      } else {
        this.$Message.error({
          content: "请选择球场与供应商",
        });
      }
    });
  }
  checkObjRule = {
    courtId: [
      {
        required: true,
        validator: this.checkCourtId,
        trigger: "change",
      },
    ],
    supplierId: [
      {
        required: true,
        validator: this.checkSupplierId,
        trigger: "change",
      },
    ],
  };
  cancel() {
    this.init();
    this.$emit("input", false);
    this.current = 0;
  }
  init() {
    this.current = 0;
    this.checkObj = new CheckObj();
    this.supplierOffer = new SupplierOffer();
    this.$store.commit("supplierOfferItem/setList");
    this.$store.commit("offerTimeSlot/setList");
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
      this.init();
    } else {
      if (this.$props.supplierId > 0 && this.$props.courtId > 0) {
        this.$set(this.checkObj, "courtId", this.$props.courtId);
        this.$set(this.checkObj, "supplierId", this.$props.supplierId);
      }
    }
  }
  async created() {
    this.getSupplierList().then(() => {
      this.getCourtList();
    });
  }
  async getCourtList() {
    let reponse = await Ajax.get("/api/services/app/Court/GetAllCourtNames");
    this.courtList = reponse.data.result;
  }
  async getSupplierList() {
    return await this.$store
      .dispatch({
        type: "supplier/GetAllSupplierListLabelAndValue",
      })
      .then((res) => {
        if (res && res.data && res.data.result) {
          this.supplierList = res.data.result;
        }
      });
  }
  /**
   * 校验人数
   */
  checkPersonNumber(rule: any, value: any, callback: any) {
    if (this.supplierOffer.personNumber >= 1) {
      callback();
    } else {
      callback(new Error("请输入正确的人数"));
    }
  }
  supplierOfferRule = {
    personNumber: [
      {
        required: true,
        validator: this.checkPersonNumber,
        trigger: "change",
      },
    ],

    days: [
      {
        type: "number",
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("OrderDays")),
        trigger: "blur,change",
      },
      {
        type: "number",
        min: 1,
        message: "必须是有效的整数",
        trigger: "blur,change",
      },
    ],
    isOnSale: [
      {
        required: true,
      },
    ],
    cancelDate: [
      {
        type: "number",
        required: true,
        message: "请设置退款时间",
        trigger: "blur,change",
      },
    ],
  };
  //#endregion
}
